module.exports = __webpack_public_path__ + "static/media/Laston Mangala Hamoonga.3e340402.jpg";